'use strict';

angular.module('amexReconciliationApp')
  .component('reallocateTransactionsModal', {
    templateUrl: 'scripts/views/modals/reallocate-transactions-modal.html',
    bindings: {
      closeModalCallback: '<'
    },
    controller: function (SiteConfigModel,
                          ReallocateTransactionsService,
                          PreviouslyUsedAccountingFieldValuesModel,
                          SelectedTransactionService) {
      var self = this;
      var applyingReallocations;

      self.$onInit = function () {
        applyingReallocations = false;

        self.reallocationAccountingFields = _.map(SiteConfigModel.getAccountingFieldSchemas(), function (accountingField) {
          return {
            displayIndex: accountingField.displayIndex,
            position: accountingField.position,
            label: accountingField.label,
            required: accountingField.required,
            protected: accountingField.protected,
            overrideEnabled: false,
            maskPattern: accountingField.maskPattern,
            validationComboId: accountingField.validationComboId,
            validationIndicator: accountingField.validationIndicator,
            validationComboPosition: accountingField.validationComboPosition,
            value: ''
          };
        });

        self.descriptionFieldObject = {
          overrideEnabled: false,
          description: ''
        };
        
        self.allocation = {accountingFieldValues: self.reallocationAccountingFields};
        getComboFieldFlag();
      };

      self.closeModal = self.closeModalCallback;

      self.selectedTransactionCount = function () {
        return SelectedTransactionService.selectedTransactionsCount();
      };

      self.isApplyDisabled = function () {
        var anyCheckboxSelected = _.some(self.reallocationAccountingFields, ['overrideEnabled', true]) || self.descriptionFieldObject.overrideEnabled;
        return !anyCheckboxSelected || applyingReallocations;
      };

      self.isSpinnerDisplayed = function() {
        return applyingReallocations;
      };

      function getSchema(position) {
        var schema =  _.find(SiteConfigModel.getAccountingFieldSchemas(), {position: position});
        if(schema) {
          return schema;
        }
        return null;
      }

      function getComboFieldFlag() {
        var comboFieldFlag = { allocationIndex: 0, validationComboId: 0};

        _.forEach(self.allocation.accountingFieldValues, function (accountingFieldValue) {
          if (accountingFieldValue.isFocused) {
            comboFieldFlag = {
              allocationIndex: 0,
              validationComboId: _.get(getSchema(accountingFieldValue.position),'validationComboId',0)
            };
          }
        });

        self.comboFieldFlag = comboFieldFlag;
      }

      self.updateAllocationsValidity = function (allocationIndex, fieldPosition, invalid, isFocused) {
        var positionIndex = _.findIndex(self.allocation.accountingFieldValues, ['position', fieldPosition]);
        self.allocation.accountingFieldValues[positionIndex].invalid = invalid;
        self.allocation.accountingFieldValues[positionIndex].isFocused = isFocused;
        getComboFieldFlag();
      };
      
      self.refreshMaskValidationErrorsCount = getComboFieldFlag;
      

      self.applyReallocations = function () {
        applyingReallocations = true;
        self.showSaveFailure = false;

        var reallocatedFields = [];
        _.forEach(self.reallocationAccountingFields, function (accountingField) {
          if (accountingField.overrideEnabled) {
            reallocatedFields.push({
              position: accountingField.position,
              value: accountingField.value
            });
          }
        });

        ReallocateTransactionsService.reallocateTransactions(
          SelectedTransactionService.selectedTransactions(),
          reallocatedFields,
          self.descriptionFieldObject.overrideEnabled? self.descriptionFieldObject.description: null
        )
          .then(function () {
            PreviouslyUsedAccountingFieldValuesModel
              .refreshPreviouslyUsedAccountingFieldValues();
            self.closeModal();
          })
          .catch(function () {
            self.showSaveFailure = true;
            applyingReallocations = false;
          });
      };

      self.clearLowerComboValues = function(allocationIndex, fieldPosition) {
        var comboId = getValidationComboId(fieldPosition);

        if (comboId > 0) {
          var displayIndex = getDisplayIndex(fieldPosition);

          _.forEach(self.reallocationAccountingFields, function (accountingFieldValue) {
            var validationComboId = getValidationComboId(accountingFieldValue.position);
            if (comboId > 0 && validationComboId == comboId && accountingFieldValue.displayIndex > displayIndex) {
              accountingFieldValue.value = '';
            }
          });
        }
        
      };

      self.isDescriptionRequired = function () {
        var transactionList = SelectedTransactionService.selectedTransactions();
        var cardTypes = _.keys(_.countBy(transactionList, 'cardTypeCode'));
        return _.some(cardTypes, function (cardTypeCode) {
          var cardType = _.find(SiteConfigModel.siteConfig().cardTypes, {'cardTypeCode': cardTypeCode});
          if(cardType) {
            return cardType.allocationDescriptionRequired;
          }
          return false;
        });
      };


      function getValidationComboId(position) {
        return _.get(getSchema(position),'validationComboId',0);
      }

      function getDisplayIndex(position) {
        return _.get(getSchema(position),'displayIndex',0);
      }
    }
  });



//////////////////
// WEBPACK FOOTER
// ./src/main/resources/static/scripts/directives/reallocateTransactionsModal.js
// module id = 531
// module chunks = 0